module.exports = __webpack_public_path__ + "static/img/view6-2.a018bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view6-2.png
// module id = M89+
// module chunks = 1